import { supportEmail } from "./external";

export const faqs = (surveyEndDate: string) => [
  {
    question: 'Do I need to complete every section to submit?',
    answer:
      'No – you can skip any questions or sections that aren’t relevant to your organisation or for which you don’t have data. This will allow you to evaluate how you are currently performing in areas where you are taking action. However, we will still include advice on best practice on the areas you are not doing to help you develop.'
  },
  {
    question:
      'How will my performance be communicated publicly? Can my organisation enter the Index anonymously?',
    answer:
      'Yes, you can enter anonymously. This means that you will not be included in any external communications, but you will still receive the same level of support, as well as the valuable individual feedback report. Employers will be assessed and placed into one of the following bands based on their performance against the Index scoring framework:<br/><br/>• <b>Pioneering</b> – Employers demonstrating outstanding practice across all areas.<br/>• <b>Progressive</b> – Employers performing strongly across most areas, with evidence of sustained progress.<br/>• <b>Established</b> – Employers meeting key baseline standards of good practice and actively developing their approach.<br/>• <b>Committed</b> – Employers who have shown a commitment to social mobility and are setting the foundations.<br/><br/>Before we publish our Pioneering, Progressive and Established employers, we\'ll inform our communities of the change alongside descriptions of what each band represents.<br/><br/>During our launch, we will publish a full list of the top three bands (unless organisations choose to remain anonymous). We will also, as usual, share case studies and spotlight features, particularly for those in the top band, and those pioneering innovative practice.<br/><br/>We will share with all participating employers a tailored communications pack, which will include logos, your certification mark, and suggested messaging. We encourage all entrants to share their commitment to the Index!'
  },
  {
    question:
      'What is the best way to measure and benchmark the number of employees from a lower socioeconomic background in our workforce?',
    answer:
      'The best resource for this is the Social Mobility Commission’s Cross Industry Toolkit, which includes the best questions to ask in diversity surveys, how to analyse them and relevant benchmarks for the workforce.'
  },
  {
    question: 'Do we need to enter every year?',
    answer:
      'The Index is most valuable when employers enter annually as you can make continual improvements and monitor your progress. It also helps you to respond to evolving best practice; each year we review our advice and guidance in line with the latest research and guidance. However, some employers use the Index as a one-off benchmarking tool.'
  },
  {
    question: 'Is it suitable for small organisations and charities?',
    answer:
      'Yes. While some questions may be more relevant to larger organisations, you can skip any questions you can’t answer, and you will still receive a personalised feedback report with best practice. The Index is also free for third sector organisations and small organisations with fewer than 50 employees.'
  },
  // {
  //   question: 'What is the cost of entering the Index?',
  //   answer:
  //     'The cost for entering the Index is £1,200 +VAT, which you will need to pay before receiving your report. Third sector organisations and small businesses (fewer than 50 employees) are exempt from the entrant fee. There are additional sectoral insights available for £500 + VAT for the legal sector, financial, banking and insurance sector and professional services sector.'
  // },
  // {
  //   question: 'How can I pay the entry fee?',
  //   answer:
  //     'Organisations can pay via card payment, or we can send you an invoice when the entry window closes. Payment should be made within 30 days of the invoice date. Unless your organisation is exempt, you must pay the entry fee to receive your personalised feedback report and be included in the benchmarking process.'
  // },
  {
    question: 'What is assessed in the Index?',
    answer:
      'The Index assesses eight areas: schools outreach and work with young people, attraction and university outreach, recruitment and selection, routes into the employer, data collection, pay, progression and retention, progression, culture and internal advocacy and external advocacy.'
  },
  // {
  //   question:
  //     'Can we get additional support or ask further questions after we receive our feedback report?',
  //   answer:
  //     `We offer one-to-one calls to discuss the contents of your feedback report, answer any questions you might have and advise you on how to implement the recommendations in your organisation for an additional cost. Please get in contact via ${supportEmail} to find out more.`
  // },
  {
    question: 'Can we see the mark scheme?',
    answer:
      'The Index mark scheme is confidential and so cannot be shared, but questions and the best practice in our Insights Report will help to guide your submission. We would also recommend reviewing the Social Mobility Commission’s resources for employers.'
  },
  // {
  //   question: 'When is the deadline for submission?',
  //   answer:
  //     `The Index will close for submissions at midnight on ${surveyEndDate}.`
  // },
  // {
  //   question: 'When will we receive our feedback?',
  //   answer: 'We share feedback reports in September.'
  // },
  {
    question: 'How can we ask further questions?',
    answer:
      `Please get in touch via email at ${supportEmail} and the Index team will be happy to help.`
  }
];
